import { useState } from "react";
import {
  AmazonItemsApi,
  ResponseRegistAmazonItemsResponse,
  RequestRegistAmazonItemsRequest,
  AmazonItemsRegisterAmazonItemsPostRequest,
  RequestBulkRegisterAmazonItemsRequest,
  AmazonItemsRegisterBulkAmazonItemsPostRequest,
  ResponseBulkRegisterAmazonItemsResponse,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiBulkRegisterAmazonItems = () => {
  const [_, setRegistedItems] =
    useState<ResponseBulkRegisterAmazonItemsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const bulkRegisterAmazonItems = async (
    req: RequestBulkRegisterAmazonItemsRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonItemsRegisterBulkAmazonItemsPostRequest = {
        req,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsRegisterBulkAmazonItemsPost(
        request
      );
      setRegistedItems(response);
      return response;
    } catch (err) {
      setError("商品の登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { bulkRegisterAmazonItems, error, setError, isLoading };
};
